export default {"src":"/_next/static/media/icon-alert-bubble.bc54a37a.svg","height":23,"width":20,"blurWidth":0,"blurHeight":0};